import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  avatar: {
    borderRadius: '2px',
    borderStyle: 'solid',
    borderWidth: '1px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  container: {
    borderRadius: theme.spacing(1),
    padding: 0,
    width: '100%',
    height: '100%',
  },
  file_unknown: {
    alignContent: 'center',
    alignItems: 'center',
    borderColor: theme.palette.primary.main,
    borderRadius: theme.spacing(2),
    borderStyle: 'solid',
    borderWidth: '1px',
    display: 'flex',
    height: theme.spacing(8),
    justifyContent: 'center',
    margin: 'auto',
    width: theme.spacing(8),
  },
  file_container: {
    alignItems: 'center',
    borderColor: '#3E8649',
    borderRadius: '20px',
    borderStyle: 'dashed',
    borderWidth: '2px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '200px',
    padding: theme.spacing(2),
    justifyContent: 'space-evenly',
    [theme.breakpoints.down('xs')]: {
      minHeight: '180px',
    },
  },
  file_button: {
    width: '100%',
    maxWidth: '220px',
    height: '42.6px',
  },
  file_icon: {
    width: '50px',
    height: '50px',
  },
  upload_icon: {
    width: '60px',
    height: '60px',
    color: '#25D366',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  preview: {
    width: '100%',
    height: '200px',
    position: 'relative',
  },
  preview_image: {
    width: 'calc(100% - 20px)',
    height: '180px',
    position: 'absolute',
    top: '10px',
    left: '10px',
    borderRadius: '10px',
    objectFit: 'cover',
  },
  preview_button: {
    position: 'absolute',
    top: '0',
    right: '0',
    marginRight: '15px',
    backgroundColor: '#fe0000',
  },
}));
